import { useCallback, useState } from "react";
import "./Locations.css";
import LocationPreview from "../../Components/LocationPreview/LocationPreview";
import ModalWindow from "../../Components/ModalWindow/ModalWindow";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { removeLocation } from "../../features/locationSlice";
import { logout } from "../../features/userSlice";
import {
  useFetchLocationsData,
  useRemoveLocation,
} from "../../hooks/useLocationData";
import { useFetchCategories } from "../../hooks/useCategory";
import Paginate from "../../Components/Paginate/Paginate";
import debounce from "lodash.debounce";
import AdminNavigationLinks from "../../Components/AdminNavigationLinks/AdminNavigationLinks";
// import axiosConfig from "../../config/axios";

const ITEMS_PER_PAGE = 10;

const Locations = () => {
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchValue);
  const [searchCategory, setSearchCategory] = useState("");

  const [deleteLocation, setDeleteLocation] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const { mutate: deletingLocation } = useRemoveLocation();
  const [isRefetchingLocations, setIsRefetchingLocations] = useState(false);

  const [pageNumber, setPageNumber] = useState(1); // Start at 1 for API

  const { data: categories, isLoading: isLoadingCategories } =
    useFetchCategories();

  const { locations, isLoading, refetch } = useFetchLocationsData(
    debouncedSearchQuery,
    searchCategory,
    pageNumber,
    ITEMS_PER_PAGE,
  );

  const dispatch = useDispatch();

  const confirmDeletingLocation = () => {
    setIsDeleting(true);
    deletingLocation(deleteLocation.id);
    setIsDeleting(false);
    setDeleteLocation(null);
  };

  const debouncedSetSearchQuery = useCallback(
    debounce((value) => {
      setDebouncedSearchQuery(value);
    }, 1000),
    [],
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    debouncedSetSearchQuery(value);
    setPageNumber(1);
  };

  const handleLogOut = async (e) => {
    e.preventDefault();

    try {
      sessionStorage.removeItem("user");
      dispatch(logout());
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleRefetchLocations = async () => {
    setIsRefetchingLocations(true);
    try {
      await refetch();
    } catch (error) {
      console.log(error);
    } finally {
      setIsRefetchingLocations(false);
    }
  };
  //Privremeno zakomentarisano jer feature nije deo aktivnog UI-ja.
  // Ako zatreba ponovo:
  // 1. odkomentarisati axiosConfig import
  // 2. odkomentarisati ovaj blok
  // 3. vratiti dugme koje poziva handleExportLocationsWithoutImages
  // const getLocationName = (location) => {
  //   return location.nameLat || location.nameEng || location.nameCir || "-";
  // };

  // const getCategoryName = (location) => {
  //   if (Array.isArray(location.category) && location.category.length > 0) {
  //     return location.category
  //       .map(
  //         (category) =>
  //           category.nameLatin ||
  //           category.nameEnglish ||
  //           category.nameCyrillic ||
  //           "",
  //       )
  //       .filter(Boolean)
  //       .join(", ");
  //   }

  //   if (location.category && typeof location.category === "object") {
  //     return (
  //       location.category.nameLatin ||
  //       location.category.nameEnglish ||
  //       location.category.nameCyrillic ||
  //       "-"
  //     );
  //   }

  //   if (Array.isArray(location.categories) && location.categories.length > 0) {
  //     return location.categories
  //       .map(
  //         (category) =>
  //           category.nameLatin ||
  //           category.nameEnglish ||
  //           category.nameCyrillic ||
  //           "",
  //       )
  //       .filter(Boolean)
  //       .join(", ");
  //   }

  //   if (
  //     location.primaryCategory &&
  //     typeof location.primaryCategory === "object"
  //   ) {
  //     return (
  //       location.primaryCategory.nameLatin ||
  //       location.primaryCategory.nameEnglish ||
  //       location.primaryCategory.nameCyrillic ||
  //       "-"
  //     );
  //   }

  //   return "-";
  // };

  // const getSubcategoryNames = (location) => {
  //   if (!Array.isArray(location.subcat) || location.subcat.length === 0) {
  //     return "-";
  //   }

  //   return location.subcat
  //     .map((sub) => sub.nameLatin || sub.nameEnglish || sub.nameCyrillic || "")
  //     .filter(Boolean)
  //     .join(", ");
  // };

  // const hasNoImages = (location) => {
  //   return !Array.isArray(location.images) || location.images.length === 0;
  // };

  // const escapeCsvValue = (value) => {
  //   const stringValue = String(value ?? "");

  //   return `"${stringValue.replace(/"/g, '""')}"`;
  // };

  // const downloadCsvFile = (rows, fileName) => {
  //   const csvContent = rows
  //     .map((row) => row.map(escapeCsvValue).join(";"))
  //     .join("\n");

  //   const blob = new Blob([`\uFEFF${csvContent}`], {
  //     type: "text/csv;charset=utf-8",
  //   });

  //   const url = URL.createObjectURL(blob);
  //   const link = document.createElement("a");

  //   link.href = url;
  //   link.download = fileName;

  //   document.body.appendChild(link);
  //   link.click();

  //   document.body.removeChild(link);
  //   URL.revokeObjectURL(url);
  // };

  // const handleExportLocationsWithoutImages = async () => {
  //   try {
  //     setIsRefetchingLocations(true);

  //     const { data } = await axiosConfig.get("/admin/locations", {
  //       params: {
  //         pageNumber: 1,
  //         pageSize: 20000,
  //       },
  //     });

  //     const allLocations = data?.locations || [];
  //     const locationsWithoutImages = allLocations.filter(hasNoImages);

  //     const csvRows = [
  //       ["Naziv Lokaliteta", "Kategorija", "Podkategorija"],
  //       ...locationsWithoutImages.map((location) => [
  //         getLocationName(location),
  //         getCategoryName(location),
  //         getSubcategoryNames(location),
  //       ]),
  //     ];

  //     downloadCsvFile(
  //       csvRows,
  //       `lokaliteti-bez-slika-${new Date().toISOString().slice(0, 10)}.csv`,
  //     );

  //     console.log("Total locations:", allLocations.length);
  //     console.log("Locations without images:", locationsWithoutImages.length);
  //   } catch (error) {
  //     console.error("Error exporting locations without images:", error);
  //   } finally {
  //     setIsRefetchingLocations(false);
  //   }
  // };

  if (isLoading || isLoadingCategories)
    return (
      <div className="invisibleWrapper">
        <p className="loadingText">Loading...</p>
      </div>
    );

  return (
    <div className="locationsWrapper">
      <div className="titleContainer">
        {/* <p className="link">
          <Link to="/admin" onClick={() => dispatch(removeLocation())}>
            Admin panel
          </Link>
        </p> */}
        <AdminNavigationLinks />

        <h1>Pretraga lokacija</h1>
        <button className="logout" onClick={handleLogOut}>
          Izloguj se
        </button>
      </div>
      <div>
        <button onClick={handleRefetchLocations} style={{ margin: "0" }}>
          Osvezi lokacije
        </button>
      </div>
      <div className="searchboxWrapper">
        <div>
          <label>
            Pretraga lokaliteta se automatski pokrece nakon unosa dva karaktera
            u polje za pretragu
          </label>
          <input
            type="text"
            placeholder="Unesi naziv lokaliteta..."
            value={searchValue}
            onChange={handleSearchChange}
          />
        </div>
        <div className="selectCategoryContainer">
          <label>Izaberi kategoriju</label>
          <select
            defaultValue=""
            onChange={(e) => setSearchCategory(e.target.value)}
          >
            <option value="">Sve kategorije</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.nameLatin}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="locationsContainer">
        {locations?.locations.map((location) => {
          return (
            <LocationPreview
              key={location.id}
              location={{ ...location }} // Prikazuje primaryCategory
              setDeleteLocation={setDeleteLocation}
            />
          );
        })}
      </div>

      {searchValue === "" && (
        <div className="paginationButtonsContainer">
          <Paginate
            pageNumber={pageNumber}
            itemsPerPage={ITEMS_PER_PAGE}
            pageCount={Math.ceil((locations?.totalCount || 0) / ITEMS_PER_PAGE)}
            onPageChange={(page) => {
              setPageNumber(page);
            }}
          />
        </div>
      )}

      {deleteLocation && (
        <ModalWindow
          title="Da li ste sigurni da zelite da obrisete lokalitet?"
          setDeleteData={setDeleteLocation}
          confirmDeletingData={confirmDeletingLocation}
        />
      )}
      {(isLoading || isDeleting || isRefetchingLocations) && (
        <div className="invisibleWrapper">
          <p className="loadingText">Loading...</p>
        </div>
      )}
    </div>
  );
};

export default Locations;
